import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from 'i18next';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { Title } from '../Title';
export const ExternalPaymentMessage = () => {
    return (_jsxs(Flex, { alignItems: "center", direction: "column", py: 8, textAlign: "center", children: [_jsx(Spinner, { color: "primary.500", size: "xl", thickness: "6px" }), _jsx(Box, { mb: 4, mt: 6, children: _jsx(Title, { type: "h3", children: t('payments/processing-payment') }) }), _jsx(Text, { textAlign: "center", children: t('payments/get-ready-to-pay') }), _jsx(Text, { textAlign: "center", children: t('payments/payment-being-processed') })] }));
};
